const isCount = value => Number.isSafeInteger(value) && value >= 0;

// Deferrals take precedence over verification in the archived listing categories.
// Use this same population for the current card and every historical point.
export function dashboardListingPopulation(snapshot) {
  const total = snapshot?.inventory?.activeListings;
  const items = snapshot?.compliance?.categories;
  const keys = ['licensed', 'violation', 'needsAttention', 'deferred'];
  if (!isCount(total) || !Array.isArray(items) || items.length !== keys.length) return null;
  const counts = keys.map(key => items.filter(item => item?.key === key));
  if (counts.some(matches => matches.length !== 1 || !isCount(matches[0].count))) return null;
  const [licensed, violation, unverified, deferred] = counts.map(matches => matches[0].count);
  if (licensed + violation + unverified + deferred !== total) return null;
  const verified = licensed + violation;
  const included = verified + unverified;
  return { total, verified, unverified, deferred, included, rate: included > 0 ? verified / included : null };
}

export function normalizeDashboardPlatform(source) {
  const key = typeof source === 'string' ? source.trim().toLowerCase() : '';
  return key === 'booking.com' ? 'booking' : key || 'unknown';
}

// A complete distribution lets an absent platform mean zero. Missing or partial
// distributions must remain gaps, even when some individual rows look valid.
export function dashboardPlatformCounts(inventory) {
  const rows = inventory?.bySource;
  if (!isCount(inventory?.activeListings) || !Array.isArray(rows)) return null;
  const counts = new Map();
  const seen = new Set();
  let total = 0;
  for (const row of rows) {
    if (!row || typeof row.source !== 'string' || !row.source.trim() || !isCount(row.count) || seen.has(row.source)) return null;
    seen.add(row.source);
    const source = normalizeDashboardPlatform(row.source);
    counts.set(source, (counts.get(source) || 0) + row.count);
    total += row.count;
  }
  if (!isCount(total) || total !== inventory.activeListings) return null;
  return [...counts].map(([source, count]) => ({ source, count }));
}
